import { Component, OnInit, ViewChild } from '@angular/core';
import { AdvanceService } from 'src/app/shared/services/advance.service';
import { tap, map } from 'rxjs/operators';
import { TableDataSource } from 'src/app/shared/components/table/table-data-source';
import { Advance, AdvanceCloseActions } from 'src/app/shared/models/advance.model';
import { MatSort } from '@angular/material/sort';
import { tableSortFn } from 'src/app/shared/utils/sort.util';
import { ToastrService } from 'ngx-toastr';
import { Router } from '@angular/router';
import { FileSaverService } from 'ngx-filesaver';
import {Redirect} from '../../../shared/utils/redirect.util';
import {ConfirmService} from '../../../shared/services/confirm.service';
import { EmployeeService } from 'src/app/shared/services/employee.service';
import { Employee } from 'src/app/shared/models/employee.model';

@Component({
  selector: 'app-advances-employees',
  templateUrl: './advances-employees.component.html'
})
export class AdvancesEmployeesComponent implements OnInit {
  advances: Advance[];
  employees$;
  advances$;

  dataSource = new TableDataSource<Advance>();
  displayedColumns: string[] = ['employee.person.lastName', 'name', 'status.name', 'leftValue', 'createdAt', 'action'];
  @ViewChild(MatSort, { static: false }) set sort(sort: MatSort) {
    this.dataSource.sort = sort;
  }

  constructor(
    private advanceService: AdvanceService,
    private toastrService: ToastrService,
    private router: Router,
    private fs: FileSaverService,
    private redirect: Redirect,
    private confirmService: ConfirmService,
    private employeeService: EmployeeService,
  ) { }

  ngOnInit() {
    this.advances$ = this.advanceService.fetchAdvances().pipe(
      map((advances: Advance[]) => {
        this.advances = this.dataSource.data = advances;
        this.dataSource.sortingDataAccessor = tableSortFn;
        return advances;
      })
    );

    this.employees$ = this.employeeService.activeEmployees$;
  }

  export(advanceId: number) {
    const filename = Date.now() + '.csv';
    this.toastrService.success('Za moment uruchomi się pobieranie pliku przelewu.');
    this.advanceService
      .exportAdvance(advanceId).subscribe(_ => {
        this.advanceService
          .exportToCsv(advanceId)
          .subscribe(result => {
            this.fs.save(result, filename);
          }, _ => this.toastrService.error('Wystąpił problem z wygenerowaniem pliku przelewu.'));
          this.redirect.to();
      }, _ => this.toastrService.error('Zaliczki nie można wyeksportować, ponieważ może zawierać jeszcze nierozliczone koszty.'));
  }

  cancel(advance: Advance) {
    if (advance.canCancel) {
      this.confirmService.openConfirmDialog('Czy na pewno chcesz anulować zaliczkę? Zmiana będzie nieodwracalna.')
        .afterClosed().subscribe(confirm => {
        if (confirm) {
          this.advanceService.cancelAdvance(advance.id).subscribe(res => {
            this.toastrService.success('Zaliczka została anulowana.');
            this.redirect.to();
          }, _ => this.toastrService.error('Zaliczka nie może zostać anulowana.'));
        }
      });
    }
  }

  onSelectEmployee(employee: Employee) {
    if (employee) {
      this.dataSource.data = this.advances.filter((delegation: any) => delegation.employee.id === employee.id);
      return;
    }
    this.dataSource.data = this.advances;
  }

}
